<div renderReact [reactComponent]="ReactComponent"></div>